<template>
  <b-card>
    <div class="flex mb-2 gap-3 items-center">
      <b-img
        class="cursor-pointer mt-[-0.5rem]"
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt=""
        @click="$router.back()"
      />
      <h4>
        <strong class="text-black text-2xl">{{ pageTitle }}</strong>
      </h4>
    </div>
    <div>
      <steps
        :steps-data="stepsData"
        :current-step="currentStep"
      />
    </div>
    <b-overlay
      :show="disable"
      rounded="sm"
    >
      <div>
        <b-form @submit.prevent="onSubmit">
          <step-one
            v-show="currentStep === 1"
            :form-data="formData"
            :disable-next.sync="disableNext.first"
            @update:brand="value => (formData.brand = value)"
            @update:name="value => (formData.name = value)"
            @update:phone_number="value => (formData.phone_number = value)"
            @update:gender="value => (formData.gender = value)"
            @update:language_style="value => (formData.language_style = value)"
            @update:greeting="value => (formData.greeting = value)"
            @update:job_description="value => (formData.job_description = value)"
          />
          <step-two
            v-show="currentStep === 2"
            :disable-next.sync="disableNext.second"
            :form-data="formData"
            :is-edit-mode="isEditMode"
            :has-invalid-price.sync="hasInvalidPrice"
            :invalid-price-products.sync="invalidPriceProducts"
            @update:address-id="value => (formData.address_id = value)"
            @table-change="onProductTableChange"
            @update:discount-type="val => productDiscountType = val"
          />
          <step-three
            v-show="currentStep === 3"
            :disable-next.sync="disableNext.third"
            :form-data="formData"
            :is-edit-mode="isEditMode"
          />
          <step-four
            v-show="currentStep === 4"
            :disable-next.sync="disableNext.fourth"
            :form-data="formData"
            :has-invalid-price="hasInvalidPrice"
            :invalid-price-products="invalidPriceProducts"
            :bank-accounts="bankAccounts"
          />
          <step-five
            v-show="currentStep === 5"
            :form-data="formData"
          />
          <div class="text-end mt-4">
            <b-button
              :disabled="currentStep <= 1"
              class="mr-1"
              variant="outline-secondary"
              size="sm"
              @click="prevStep"
            >
              Back
            </b-button>
            <b-button
              v-show="currentStep < stepsData.length"
              size="sm"
              variant="primary"
              :disabled="currentStep >= stepsData.length || handleDisableNext()"
              @click="nextStep"
            >Next
            </b-button>
            <b-button
              v-show="currentStep >= stepsData.length"
              size="sm"
              :disabled="isAnyFormDataEmpty()"
              variant="primary"
              @click="onSubmit"
            >
              {{ isEditMode ? 'Update' : 'Simpan' }}
            </b-button>
          </div>
        </b-form>
      </div>
    </b-overlay>
  </b-card>
</template>
<script>
import steps from '@/views/components/steps/steps.vue'
import stepOne from './StepOne.vue'
import stepTwo from './StepTwo.vue'
import stepThree from './StepThree.vue'
import stepFour from './StepFour.vue'
import stepFive from './StepFive.vue'
import { jobdesc, stepsData } from './config'

import { apiCreateAgent, apiGetAgentDetail, apiUpdateAgent } from './service/api.agent.service'

export default {
  name: 'AddAiCustomerService',
  components: {
    steps,
    stepOne,
    stepTwo,
    stepThree,
    stepFour,
    stepFive,
  },
  data() {
    return {
      isEditMode: false, // Add this line to track edit mode
      currentStep: 1,
      whatsAppList: this.$store.state.komchat.whatsAppList,
      productList: this.$store.state.komchat.productList,
      stepsData,
      formData: {
        phone_number: '',
        name: '',
        brand: '',
        gender: '',
        language_style: '',
        greeting: '',
        job_description: jobdesc,
        is_off_when_manually: false,
        payment_method: ['COD', 'KOMERCE'],
        address_id: null,
        shipments: [],
        product_ids: [],
        products: [],
        bank_account_ids: [],
        times: [],
        product_discount: 0,
        payment_discount: 0,
        shipping_discount: 0,
        type_shipping_discount: 'percentage',
        minimum_shipping_discount: 0,
        coverage_discount: '',
        reminder: [],
        email_close_order: false,
        human_handover: {
          is_active: false,
          is_keyword_trigger: false,
          keywords: [],
          is_negative_sentiment: false,
          is_auto_return_cs_ai: false,
          auto_return_cs_ai_minutes: 15,
        },
        meta_capi_config: {
          is_active: false,
          pixel_name: '',
          pixel_id: '',
          access_token: '',
          event_test_code: '',
          events: [],
          meta_events: [],
        },
      },
      bankAccounts: [],
      productDiscountType: 'percentage',
      disableNext: {
        first: false,
        second: false,
        third: false,
        fourth: false,
        fifth: false,
      },
      disable: false,
      isSubmitted: false,
      hasInvalidPrice: false,
      invalidPriceProducts: [],
    }
  },
  computed: {
    pageTitle() {
      return this.isEditMode ? 'Edit Customer Service Personality' : 'Customer Service Personality'
    },
    isFormDirty() {
      const fd = this.formData
      return !!(
        fd.brand
        || fd.name
        || fd.phone_number
        || (fd.products && fd.products.length > 0)
        || (fd.shipments && fd.shipments.length > 0)
        || (fd.bank_account_ids && fd.bank_account_ids.length > 0)
        || this.currentStep > 1
      )
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isSubmitted || to.name === 'koneksi-wa') {
      next()
      return
    }

    if (this.isFormDirty) {
      this.$swal({
        title: 'Tinggalkan Halaman?',
        text: 'Perubahan data yang belum disimpan akan hilang jika kamu meninggalkan halaman ini.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, Tinggalkan',
        cancelButtonText: 'Batal',
        customClass: {
          confirmButton: 'btn btn-primary mr-1',
          cancelButton: 'btn btn-outline-secondary',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          next()
        } else {
          next(false)
        }
      })
    } else {
      next()
    }
  },
  async mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    await this.$store.dispatch('komchat/getWhatsAppList')
    if (this.$route.params.id) {
      this.isEditMode = true
      try {
        await this.getAgentById()
        await this.$store.dispatch('komchat/getProductList', {
          keyword: '',
          page: 0,
          limit: 20,
          append: false,
        })
        await this.$store.dispatch('komchat/getWarehouseList')
      } catch (error) {
        console.error('Error loading data:', error)
        this.$toast_error({ message: 'Gagal memuat data' })
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    nextStep() {
      if (this.currentStep < this.stepsData.length) {
        this.currentStep += 1
        this.updateStepStatus()
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep -= 1
        this.updateStepStatus()
      }
    },
    updateStepStatus() {
      this.stepsData = this.stepsData.map(step => ({
        ...step,
        done: step.number < this.currentStep,
      }))
    },
    titleStep() {
      return this.stepsData[this.currentStep - 1].name
    },
    handleDisableNext() {
      const map = {
        1: this.disableNext.first,
        2: this.disableNext.second,
        3: this.disableNext.third,
        4: this.disableNext.fourth,
        5: this.disableNext.fifth,
      }
      return map[this.currentStep] ?? false
    },
    onProductTableChange(rows) {
      // Store product rows with discount info for payload building
      this.formData.products = (rows || []).map(r => ({
        product_id: r.product_id || r.id,
        variant_id: r.variant_id || null,
        product_name: r.product_name,
        product_price: r.product_price,
        discount_type: this.productDiscountType || 'percentage',
        discount: r.discount || 0,
        minTransaction: r.minTransaction || 0,
      }))
    },
    buildPayload() {
      const fd = this.formData

      // Build products array with per-product discount info
      const products = (fd.products || []).map(p => ({
        product_id: p.product_id || p.id,
        variant_id: Number(p.variant_id) || null,
        type: p.discount_type || 'percentage',
        value: Number(p.discount) || 0,
        minimum: Number(p.minTransaction) || 0,
      }))

      // Map subsidy type to API value
      const typeShippingDiscount = fd.type_shipping_discount === 'nominal' ? 'nominal' : 'percentage'

      // Build times array
      const times = (fd.times || []).map(t => ({
        day_of_week: t.day_of_week,
        start_time: t.start_time || '00:00',
        end_time: t.end_time || '23:59',
        is_24_hours: !!t.is_24_hours,
      }))

      const payload = {
        phone_number: typeof fd.phone_number === 'object' && fd.phone_number ? fd.phone_number.phone_number : fd.phone_number,
        name: fd.name,
        brand: fd.brand,
        gender: fd.gender,
        language_style: fd.language_style,
        greeting: fd.greeting,
        job_description: fd.job_description,
        is_off_when_manually: fd.is_off_when_manually,
        payment_method: fd.payment_method,
        address_id: fd.address_id,
        products,
        bank_account_ids: fd.bank_account_ids,
        payment_discount: Number(fd.payment_discount) || 0,
        shipping_discount: Number(fd.shipping_discount) || 0,
        coverage_discount: fd.coverage_discount,
        type_shipping_discount: typeShippingDiscount,
        minimum_shipping_discount: Number(fd.minimum_shipping_discount) || 0,
        shipments: fd.shipments,
        times,
        reminder: fd.reminder,
        email_close_order: fd.email_close_order,
      }

      if (fd.human_handover) {
        payload.human_handover = {
          is_active: !!fd.human_handover.is_active,
          is_keyword_trigger: !!fd.human_handover.is_keyword_trigger,
          keywords: Array.isArray(fd.human_handover.keywords) ? fd.human_handover.keywords.filter(Boolean) : [],
          is_negative_sentiment: !!fd.human_handover.is_negative_sentiment,
          is_auto_return_cs_ai: !!fd.human_handover.is_auto_return_cs_ai,
          auto_return_cs_ai_minutes: Number(fd.human_handover.auto_return_cs_ai_minutes) || 15,
        }
      }

      const capiConfig = fd.meta_capi_config || fd.meta_capi
      if (capiConfig) {
        let eventsList = []
        if (Array.isArray(capiConfig.meta_events) && capiConfig.meta_events.length > 0) {
          eventsList = capiConfig.meta_events
        } else if (Array.isArray(capiConfig.events)) {
          eventsList = capiConfig.events
        }

        payload.meta_capi_config = {
          is_active: !!capiConfig.is_active,
          pixel_name: capiConfig.pixel_name || '',
          pixel_id: capiConfig.pixel_id || '',
          access_token: capiConfig.access_token || '',
          event_test_code: capiConfig.event_test_code || capiConfig.test_event_code || '',
          events: eventsList,
          meta_events: eventsList,
        }
      }

      // Clean up empty optional fields for create
      if (!this.isEditMode) {
        if (!payload.payment_discount) delete payload.payment_discount
        if (!payload.shipping_discount) delete payload.shipping_discount
        if (!payload.coverage_discount) delete payload.coverage_discount
        if (!payload.minimum_shipping_discount) delete payload.minimum_shipping_discount
      }

      return payload
    },
    handleBeforeUnload(e) {
      if (this.isFormDirty && !this.isSubmitted) {
        e.preventDefault()
        e.returnValue = ''
        return ''
      }
      return undefined
    },
    async onSubmit() {
      const idAgent = this.$route.params.id
      try {
        this.disable = true
        const payload = this.buildPayload()

        if (this.isEditMode) {
          await apiUpdateAgent(idAgent, payload)
          this.isSubmitted = true
          this.$toast_success({ message: 'Agen berhasil diperbarui' })
        } else {
          await apiCreateAgent(payload)
          this.isSubmitted = true
          this.$toast_success({ message: 'Agen berhasil dibuat' })
        }
        this.$router.push({ name: 'ai-customer-service' })
      } catch (error) {
        this.$toast_error({
          message: this.isEditMode
            ? 'Terjadi kesalahan saat memperbarui agen'
            : 'Terjadi kesalahan saat membuat agen',
        })
      } finally {
        this.disable = false
      }
    },
    async getAgentById() {
      const idAgent = this.$route.params.id
      try {
        this.disable = true
        const { data } = await apiGetAgentDetail(idAgent)

        const d = data.data || {}

        // Helper: trim time string to HH:MM (response can return HH:MM:SS)
        const trimTime = t => {
          if (!t || typeof t !== 'string') return ''
          return t.length >= 5 ? t.substring(0, 5) : t
        }

        const metaConfigRaw = d.meta_capi_config || d.meta_capi || {}
        let parsedEvents = []
        if (Array.isArray(metaConfigRaw.meta_events) && metaConfigRaw.meta_events.length > 0) {
          parsedEvents = metaConfigRaw.meta_events
        } else if (Array.isArray(metaConfigRaw.events)) {
          parsedEvents = metaConfigRaw.events
        }

        const cleanedData = {
          phone_number: d.phone_number || '',
          name: d.name || '',
          brand: d.brand || '',
          gender: d.gender || '',
          language_style: d.language || d.language_style || '',
          greeting: d.greeting || '',
          job_description: d.job_description || '',
          is_off_when_manually: !!d.is_off_when_manually,
          payment_method: (() => {
            if (Array.isArray(d.payment_method)) return d.payment_method
            if (d.payment_method) return [d.payment_method]
            return []
          })(),
          address_id: d.address_id || null,
          shipments: d.shipments || [],
          product_ids: d.products ? [...new Set(d.products.map(p => p.product_id))] : [],
          products: (() => {
            if (!d.products) return []
            const group = new Map()

            d.products.forEach(p => {
              const hasVal = Number(p.value) > 0 || Number(p.minimum) > 0
              let prod = group.get(p.product_id)

              if (!prod) {
                prod = {
                  id: p.product_id,
                  product_id: p.product_id,
                  product_name: p.name || '-',
                  product_image: p.url || '',
                  product_price: p.price || 0,
                  product_sku: p.sku || '-',
                  product_stock: '-',
                  has_variant: !!p.variant_id,
                  variants: [],
                  variantsMap: new Map(), // temporary map for O(1) lookup
                  discount_type: p.type || 'percentage',
                  discount: p.value || 0,
                  minTransaction: p.minimum || 0,
                  checked: !p.variant_id && hasVal,
                }
                group.set(p.product_id, prod)
              }

              if (p.variant_id) {
                prod.has_variant = true
                let variant = prod.variantsMap.get(p.variant_id)

                if (!variant) {
                  variant = {
                    id: `${p.product_id}-${p.variant_id}`,
                    variant_id: p.variant_id,
                    product_id: p.product_id,
                    product_name: p.name || '-',
                    product_image: p.url || '',
                    product_price: p.price || 0,
                    product_stock: '-',
                    discount_type: p.type || 'percentage',
                    discount: p.value || 0,
                    minTransaction: p.minimum || 0,
                    checked: hasVal,
                  }
                  prod.variantsMap.set(p.variant_id, variant)
                  prod.variants.push(variant)
                } else if (hasVal) {
                  variant.discount = p.value
                  variant.minTransaction = p.minimum
                  variant.checked = true
                  variant.discount_type = p.type || 'percentage'
                }
              } else if (hasVal) {
                prod.discount = p.value
                prod.minTransaction = p.minimum
                prod.checked = true
                prod.discount_type = p.type || 'percentage'
              }
            })

            // Clean up temporary maps and return array
            return Array.from(group.values()).map(({ variantsMap, ...rest }) => rest)
          })(),
          bank_account_ids: d.bank_account_ids || [],
          times: (d.times || []).map(t => ({
            day_of_week: t.day_of_week,
            start_time: trimTime(t.start_time) || '00:00',
            end_time: trimTime(t.end_time) || '23:59',
            is_24_hours: !!t.is_24_hours,
          })),
          product_discount: d.product_discount || 0,
          payment_discount: d.payment_discount || 0,
          shipping_discount: d.shipping_discount || 0,
          type_shipping_discount: d.type_shipping_discount || 'percentage',
          minimum_shipping_discount: d.minimum_shipping_discount || 0,
          coverage_discount: d.coverage_discount || '',
          reminder: d.reminder || [],
          email_close_order: !!d.email_close_order,
          human_handover: {
            is_active: !!(d.human_handover?.is_active ?? d.is_human_handover ?? false),
            is_keyword_trigger: !!(d.human_handover?.is_keyword_trigger ?? false),
            keywords: (() => {
              if (Array.isArray(d.human_handover?.keywords)) {
                return d.human_handover.keywords
              }
              if (typeof d.human_handover?.keywords === 'string' && d.human_handover.keywords) {
                return [d.human_handover.keywords]
              }
              return ['minta CS', 'bicara manusia', 'bicara dengan CS']
            })(),
            is_negative_sentiment: !!(d.human_handover?.is_negative_sentiment ?? false),
            is_auto_return_cs_ai: !!(d.human_handover?.is_auto_return_cs_ai ?? false),
            auto_return_cs_ai_minutes: Number(d.human_handover?.auto_return_cs_ai_minutes) || 15,
          },
          meta_capi_config: {
            is_active: !!metaConfigRaw.is_active,
            pixel_name: metaConfigRaw.pixel_name || '',
            pixel_id: metaConfigRaw.pixel_id || '',
            access_token: metaConfigRaw.access_token || '',
            event_test_code: metaConfigRaw.event_test_code || metaConfigRaw.test_event_code || '',
            is_connected: !!(
              metaConfigRaw.is_connected
              || (metaConfigRaw.pixel_id && String(metaConfigRaw.pixel_id).length >= 15)
            ),
            dataset_name: metaConfigRaw.dataset_name || metaConfigRaw.pixel_name || '',
            events: parsedEvents,
            meta_events: parsedEvents,
          },
        }
        this.bankAccounts = d.bank_accounts || []
        Object.assign(this.formData, cleanedData)
      } catch {
        this.$toast_error({ message: 'Terjadi kesalahan saat mengambil agen' })
      } finally {
        this.disable = false
      }
    },
    isAnyFormDataEmpty() {
      const requiredFields = [
        'phone_number',
        'name',
        'brand',
        'gender',
        'language_style',
        'greeting',
        'job_description',
        'address_id',
        'payment_method',
        'product_ids',
      ]
      if (this.formData.payment_method.includes('BANK_TRANSFER')) {
        requiredFields.push('bank_account_ids')
      }

      const mc = this.formData.meta_capi_config || this.formData.meta_capi
      if (mc?.is_active) {
        if (!mc.pixel_name || !mc.pixel_name.trim()) return true
        const pixelStr = String(mc.pixel_id || '').trim()
        if (!pixelStr || (pixelStr.length !== 15 && pixelStr.length !== 16)) return true
        if (!mc.access_token || !mc.access_token.trim()) return true
        let mcEvents = []
        if (Array.isArray(mc.meta_events) && mc.meta_events.length > 0) {
          mcEvents = mc.meta_events
        } else if (Array.isArray(mc.events)) {
          mcEvents = mc.events
        }
        if (mcEvents.length === 0) return true
      }

      const hasShipment = this.formData.shipments && this.formData.shipments.length > 0

      return requiredFields.some(field => {
        const value = this.formData[field]
        if (field === 'product_ids') {
          return !Array.isArray(value) || value.length === 0
        }
        return value === undefined || value === null || String(value).trim() === ''
      }) || !hasShipment
    },
  },
}
</script>
